module.exports = __webpack_public_path__ + "media/images/station_dot-0b2f39efb591a5c748ea8c32fd05b7ca.png";